import PropTypes from 'prop-types';
import React from 'react';

import { Small, Medium, LargeUp } from 'components/MediaQuery';
import { COLLECTION_COLORWAY_PICKER_APPEARANCES } from 'constants/collectionPage';
import Theme from 'styles/theme';

import Grid from './Grid';

const layoutPropTypes = PropTypes.arrayOf(
  PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      columnSpan: PropTypes.number.isRequired,
    })
  )
);

const CustomCollectionCardsList = ({
  layout1Column,
  layout2Column,
  layout3Column,
  layout4Column,
  nColumnsMobile,
}) => (
  <div className="CustomCollectionCardsList">
    {nColumnsMobile === 1 && (
      <Small>
        <Grid
          rows={layout1Column}
          nColumns={1}
          appearance={COLLECTION_COLORWAY_PICKER_APPEARANCES.COLOR_SWATCHES}
        />
      </Small>
    )}

    {nColumnsMobile === 2 && (
      <Small>
        <Grid
          rows={layout2Column}
          nColumns={2}
          appearance={COLLECTION_COLORWAY_PICKER_APPEARANCES.COLOR_SWATCHES}
          hasMobileQuickAddRow
        />
      </Small>
    )}

    <Medium>
      <Grid
        rows={layout3Column}
        nColumns={3}
        appearance={COLLECTION_COLORWAY_PICKER_APPEARANCES.THUMBNAILS}
        hasMobileQuickAddRow
      />
    </Medium>

    <LargeUp>
      <Grid
        rows={layout4Column}
        nColumns={4}
        appearance={COLLECTION_COLORWAY_PICKER_APPEARANCES.THUMBNAILS}
      />
    </LargeUp>

    <style jsx>
      {`
        .CustomCollectionCardsList {
          display: flex;
          flex-direction: column;
          width: 100%;
          max-width: ${Theme.get('container-width-max-px')};
          margin: 0 auto;
        }
      `}
    </style>
  </div>
);

CustomCollectionCardsList.propTypes = {
  layout1Column: layoutPropTypes.isRequired,
  layout2Column: layoutPropTypes.isRequired,
  layout3Column: layoutPropTypes.isRequired,
  layout4Column: layoutPropTypes.isRequired,
  nColumnsMobile: PropTypes.number.isRequired,
};

CustomCollectionCardsList.defaultProps = {};

export default CustomCollectionCardsList;
